import { inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

import { LG_APP_CONFIGURATION } from "@logex/framework/lg-application";
import { LgConsole } from "@logex/framework/core";

import { BehaviorSubject, lastValueFrom } from "rxjs";

import { AppVersionSettings } from "@shared";
import { urlConcat } from "@logex/framework/utilities";

@Injectable({ providedIn: "root" })
export class ScenarioSettingsService {
    private _scenarioSettings: BehaviorSubject<AppVersionSettings | null> = new BehaviorSubject(
        null
    );

    private _lgConsole = inject(LgConsole);
    private _applicationConfiguration = inject(LG_APP_CONFIGURATION);
    private _http: HttpClient = inject(HttpClient);

    scenarioSettings = this._scenarioSettings.asObservable();

    async load(clientId: number, scenarioId: number): Promise<AppVersionSettings> {
        try {
            const params = {} as any;
            if (clientId != null) params.clientId = clientId;
            if (scenarioId != null) params.scenarioId = scenarioId;

            const settings = await lastValueFrom(
                this._http.get<AppVersionSettings>(
                    urlConcat(
                        this._applicationConfiguration.applicationRoot,
                        "api/current/scenarioSettings"
                    ),
                    { params }
                )
            );

            this._scenarioSettings.next(settings);

            return settings;
        } catch (err) {
            this._lgConsole.error(
                `Error getting scenario ${scenarioId} for client ${clientId}`,
                err
            );
            return null;
        }
    }
}
